/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_P2tInputs */

const en_mk_sol_ukm_p2t = /** @type {(inputs: Mk_Sol_Ukm_P2tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer complaints pile up until the afternoon`)
};

const id_mk_sol_ukm_p2t = /** @type {(inputs: Mk_Sol_Ukm_P2tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komplain pelanggan menumpuk sampai sore`)
};

/**
* | output |
* | --- |
* | "Customer complaints pile up until the afternoon" |
*
* @param {Mk_Sol_Ukm_P2tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_p2t = /** @type {((inputs?: Mk_Sol_Ukm_P2tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_P2tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_p2t(inputs)
	return en_mk_sol_ukm_p2t(inputs)
});